import styled from 'styled-components'

export const SelectWithButton = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
  align-items: center;
`
